import { FaWhatsapp } from 'react-icons/fa'

const FloatingWhatsapp = () => {
    const handleCall = () => {
        window.open('https://api.whatsapp.com/send?phone=5549999491845', '_blank')
    }

    return (
        <div
            onClick={handleCall}
            title='Fale conosco'
            className='fixed bottom-5 left-5 w-16 h-16 bg-green-500 hover:bg-green-600 transition duration-300 rounded-full flex items-center justify-center z-50 cursor-pointer'
        >
            <FaWhatsapp className='w-8 h-8 text-white' />
        </div>
    )
}

export default FloatingWhatsapp
